"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BASE_URL: 'http://localhost:3100',
  BASE_DOMAIN: 'localhost:3100',
  CLIENT_ID: 'HcVEwgp9wDnDvd'
};